import XTbl, {Xtc} from '../../components/new-x-table/index';

const tbl = new XTbl('http://hr.asco-intl.com:2020/kernel/api/personnel/table', 'لیست پرسنل');
tbl.add(new Xtc('id', 'کد پرسنلی').filterText())
tbl.add(new Xtc('name', 'نام و نام خانوادگی').filterText());
tbl.add(new Xtc('insurance_no', 'شماره بیمه').filterText())
tbl.add(new Xtc('ncode', 'کد ملی').filterText())

tbl.add(new Xtc('proposal.mobile', 'شماره تلفن').filterText().hidden())
tbl.add(new Xtc('proposal.iden_place', 'محل صدور').filterText().hidden())
tbl.add(new Xtc('proposal.birth_place', 'محل تولد').filterText().hidden())
tbl.add(new Xtc('unit', 'واحد کار').filterText())
tbl.add(new Xtc('birth_date', 'تاریخ تولد').filterDate().filterKey('birth_date').hidden().renderSlot('birth_date'))
tbl.add(new Xtc('proposal.gender', 'جنسیت').filterSelect({1: 'مرد', 2: 'زن'}).filterKey('proposal.gender').hidden().renderSlot('gender'))

tbl.add(new Xtc('last_education_str', 'مقطع تحصیلی'))
tbl.add(new Xtc('caj', 'ثبت نام').filterDate().filterKey('created_at'))
tbl.add(new Xtc('uaj', 'به روز رسانی').filterDate().filterKey('updated_at').hidden())
tbl.add(new Xtc('operator', 'عملیات').renderSlot('operator').noSort())

export default tbl;
